import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeeBannerComponent } from './fee-banner.component';
import { CoreModule } from '@angular/flex-layout';
import { InfoBlockModule } from '@app/core/components/info-block/info-block.module';
import { PipesModule } from '@app/core/pipes/pipes.module';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [FeeBannerComponent],
    exports: [FeeBannerComponent],
    imports: [CommonModule, CoreModule, InfoBlockModule, PipesModule, RouterModule]
})
export class FeeBannerModule {}
